import React from 'react';
import formatPledgeAmount from '../../shared/utils/formatPledgeAmount';
import formatLongDate from '../../shared/utils/formatLongDate';

const fmt = (cents) => formatPledgeAmount(cents);

const FREQ_LABELS = {
  one_time: 'one-time installment',
  monthly: 'monthly installments',
  quarterly: 'quarterly installments',
  semi_annually: 'semi-annual installments',
  annually: 'annual installments',
};

export default function PledgeKpis({ pledge }) {
  const received = Number(pledge.received_amount_cents) || 0;
  const balance  = Number(pledge.balance_remaining_cents) || Number(pledge.total_amount_cents);
  const progress = Math.round(Number(pledge.progress_percent) || 0);
  const overdue  = Number(pledge.overdue_amount_cents) || 0;
  const totalReceived = received > 0;
  const totalProgress = progress > 0;

  return (
    <section className="pd-stats">
      <div className="pd-stat">
        <div className="pd-stat-top">
          <span className="pd-stat-ico pd-stat-ico-gray"><i className="fal fa-hand-holding-usd" /></span>
          <span className="pd-stat-label">Total pledged</span>
        </div>
        <div className="pd-stat-value">{fmt(pledge.total_amount_cents)}</div>
        <div className="pd-stat-sub">
          {pledge.installments_count} {FREQ_LABELS[pledge.installment_frequency] || 'installments'}
        </div>
      </div>

      <div className="pd-stat">
        <div className="pd-stat-top">
          <span className={`pd-stat-ico ${totalReceived ? 'pd-stat-ico-success' : 'pd-stat-ico-gray'}`}>
            <i className="fal fa-check-circle" />
          </span>
          <span className="pd-stat-label">Received</span>
        </div>
        <div className={`pd-stat-value ${totalReceived ? '' : 'pd-stat-value-muted'}`}>{fmt(received)}</div>
        <div className="pd-stat-sub">0 payments</div>
      </div>

      <div className="pd-stat">
        <div className="pd-stat-top">
          <span className="pd-stat-ico pd-stat-ico-brand"><i className="fal fa-wallet" /></span>
          <span className="pd-stat-label">Balance remaining</span>
        </div>
        <div className="pd-stat-value">{fmt(balance)}</div>
        <div className="pd-stat-sub">
          {overdue > 0
            ? <span className="pd-stat-sub-warn">{fmt(overdue)} overdue</span>
            : (pledge.next_due_on ? `Next due ${formatLongDate(pledge.next_due_on)}` : '—')}
        </div>
      </div>

      <div className="pd-stat">
        <div className="pd-stat-top">
          <span className={`pd-stat-ico ${totalProgress ? 'pd-stat-ico-brand' : 'pd-stat-ico-gray'}`}>
            <i className="fal fa-chart-pie" />
          </span>
          <span className="pd-stat-label">Progress</span>
        </div>
        <div className={`pd-stat-value ${totalProgress ? '' : 'pd-stat-value-muted'}`}>{progress}%</div>
        <div
          className="pd-prog-track"
          role="progressbar"
          aria-valuenow={progress}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-label="Pledge fulfillment progress"
        >
          <div className="pd-prog-fill" style={{ width: `${progress}%` }} />
        </div>
      </div>
    </section>
  );
}
